var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_4034)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 60,
    fill: "#D0FFFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_338_4034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.612 45.0517C102.612 45.0517 86.134 28.9706 66.6258 39.6871C47.1062 50.403 57.3201 73.9698 57.3201 73.9698C57.3201 73.9698 30.2224 76.9201 29.718 103.078C29.2135 129.236 59.1244 127.407 59.1244 127.407C59.1244 127.407 43.2446 147.593 66.7965 162.01C90.3484 176.428 105.479 152.372 105.479 152.372C105.479 152.372 129.362 172.233 148.833 156.723C168.303 141.214 146.929 116.374 146.929 116.374C146.929 116.374 169.943 106.387 170.765 88.3447C171.586 70.2914 141.782 69.012 141.782 69.012C141.782 69.012 158.268 51.998 136.941 37.026C118.437 24.025 102.612 45.0517 102.612 45.0517Z",
    fill: "#00B1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3214 97.4688C96.2568 97.6339 98.8089 94.6993 99.0217 90.9143C99.2346 87.1292 97.0275 83.927 94.0921 83.762C91.1567 83.5969 88.6046 86.5315 88.3918 90.3166C88.1789 94.1016 90.386 97.3038 93.3214 97.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4541 90.8942C97.3055 93.5362 95.519 95.5878 93.4678 95.4724C91.4166 95.3571 89.8713 93.1182 90.0199 90.4762C90.1684 87.8342 91.955 85.7826 94.0062 85.898C96.0574 86.0133 97.6026 88.2522 97.4541 90.8942Z",
    fill: "#51556C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.579 91.4379C114.366 95.2203 111.813 98.1576 108.878 97.9925C105.943 97.8275 103.736 94.6226 103.949 90.8403C104.161 87.0579 106.714 84.1206 109.649 84.2857C112.584 84.4507 114.791 87.6556 114.579 91.4379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7286 106.277C83.9813 111.136 92.4214 114.691 101.272 114.792C109.577 114.885 117.305 111.888 123.818 106.852C126.136 105.068 123.096 101.703 120.791 103.476C115.145 107.848 108.292 110.441 101.094 110.274C93.1576 110.089 85.7442 106.874 79.2361 102.521C76.8041 100.89 74.3066 104.668 76.7279 106.288L76.7286 106.277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.546 91.5954C112.398 94.2374 110.611 96.289 108.56 96.1736C106.509 96.0583 104.963 93.8194 105.112 91.1774C105.26 88.5354 107.047 86.4838 109.098 86.5991C111.149 86.7145 112.695 88.9534 112.546 91.5954Z",
    fill: "#51556C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_4034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_338_4034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140.031,
    height: 136.087,
    fill: "white",
    transform: "translate(33.9355 27.6667) rotate(3.21811)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserProfile);
export default __webpack_public_path__ + "static/media/icon_user_profile.4e146e1127073be8a4b6336cb364f511.svg";
export { ForwardRef as ReactComponent };